import { defineMessages } from 'react-intl';

const upgradeRatingsMessages = defineMessages({
  featureName: {
    id: 'unlock.ratings.authorized.role',
    defaultMessage: 'Visit Feedback',
  },
  featureHeading: {
    id: 'unlock.ratings.authorized.role.heading',
    defaultMessage: 'Unlock Visit Feedback',
  },
  featureSummary: {
    id: 'unlock.ratings.authorized.role.summary',
    defaultMessage: 'See what high schools think about your past visits',
  },
  featureUnlockDetails: {
    id: 'unlock.ratings.authorized.role.details',
    // eslint-disable-next-line max-len
    defaultMessage:
      "With <strong>Visit Feedback</strong> you get access to information on the effectiveness of your college visits. See what's working and what could be improved.",
  },
});

export default upgradeRatingsMessages;
